import moment from "moment";
import { Column } from "primereact/column";
import React from "react";
import { connect } from "react-redux";
import { Page } from "../../../components/page/Page";
import { AppService, BUSINESS_UNIT_CHANGE_EVENT_NAME, COMPANY_CHANGE_EVENT_NAME } from "../../../services/app.service";
import * as utils from "../../../utils";
import { actions as accountConfigurationActions } from "../../accountConfiguration/accountConfiguration.actions";
import { actions as carrierActions } from "../../carrier/carrier.actions";
import { actions } from "../hubIntegrations.actions";
import { actions as actionsImportFiles } from "../../importfiles/importfiles.actions";
import { HubIntegrationsMenu } from "../components/hubIntegrationsMenu";
import { SefazConfigurationForm } from "../form/sefazConfiigurationForm";
import "./hubIntegrationsListPageContainer.scss";
import { ApiConfigurationForm } from "../form/apiConfigurationForm";
import ImportFilesFormPageContainer from "../../importfiles/form/ImportFilesFormPageContainer";


const mapStateToProps = state => {
  return {
    columns: state.crudHubIntegrationsState.columns,
    records: state.crudHubIntegrationsState.records,
    first: state.crudHubIntegrationsState.index,
    rows: state.crudHubIntegrationsState.max,
    totalRecords: state.crudHubIntegrationsState.count,
    sortField: state.crudHubIntegrationsState.sortField,
    order: state.crudHubIntegrationsState.sortOrder,

    logCte: state.crudHubIntegrationsState.logCte,
    logNfe: state.crudHubIntegrationsState.logNfe,
    integrations: state.crudHubIntegrationsState.integrations,
    module: state.crudHubIntegrationsState.modules,
    dialogErpMenu: state.crudHubIntegrationsState.dialogErpMenu,
    dialogNfeError: state.crudHubIntegrationsState.dialogNfeError,
    dialogCteError: state.crudHubIntegrationsState.dialogCteError,
    dialogIntegrationConfiguration: state.crudHubIntegrationsState.dialogIntegrationConfiguration,
    dialogManualImport: state.crudHubIntegrationsState.dialogManualImport,
    autConfigurationOptions: state.crudHubIntegrationsState.autConfigurationOptions,
    autConfigurationValue: state.crudHubIntegrationsState.autConfigurationValue,
    passwordNfePFX: state.crudHubIntegrationsState.passwordNfePFX,
    passwordCtePFX: state.crudHubIntegrationsState.passwordCtePFX,
    currentRecord: state.crudHubIntegrationsState.records,
    credentials: state.crudHubIntegrationsState.credentials,
    messageError: state.crudHubIntegrationsState.messageError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
    sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
    applyFilter: filterParams => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams));
    },

    loadCarriers: () => dispatch(carrierActions.load()),
    loadCustomFields: () => dispatch(accountConfigurationActions.loadCustomFields()),

    initialDateChangeHandler: e => {
      dispatch(actions.setInitialDateFilter(e.value));
    },
    finalDateChangeHandler: e => {
      dispatch(actions.setFinalDateFilter(e.value));
    },
    nfeNumberChangeHandler: e => {
      dispatch(actions.setNfeNumberFilter(e.target.value));
    },
    setExpandedOrdersRows: expandedOrders => {
      dispatch(actions.setExpandedOrdersRows(expandedOrders));
    },
    setOrdersToApprove: order => {
      dispatch(actions.setOrdersToApprove(order));
    },
    approveOrder: (order) => {
      dispatch(actions.approveOrder(order));
    },

    // Dialog Approve Component
    showApproveComponentHandler: e => {
      dispatch(actions.setDialogApproveComponentVisible(true));
    },
    setDialogApproveComponentType: approvalType => {
      dispatch(actions.setDialogApproveComponentType(approvalType));
    },
    currentApproveComponentDescriptionChangeHandler: e => {
      if (e.target) {
        dispatch(actions.setCurrentApproveComponentDescription(e.target.value));
      } else
        dispatch(actions.setCurrentApproveComponentDescription(e));
    },
    hideApproveComponentHandler: e => {
      dispatch(actions.setDialogApproveComponentVisible(false));
    },
    // End Dialog Approve Component
    downloadHandle: e => {
      dispatch(actions.downloadCSV(e))
    },
    manualModuleHandler: (enable) => { dispatch(actions.enableManualModule(enable)) },
    sefazModuleHandler: (enable) => { dispatch(actions.enableSefazModule(enable)) },
    apiModuleHandler: (enable) => { dispatch(actions.enableApiModule(enable)) },
    ediModuleHandler: (enable) => { dispatch(actions.enableEdiModule(enable)) },
    showDialogErpMenu: (enable) => { dispatch(actions.showDialogErpMenu(enable)) },
    showDialogErpConfiguration: (enable, name) => { dispatch(actions.showDialogErpConfiguration(enable, name)) },
    changeAutHandler: (value) => { dispatch(actions.setAutValue(value)) },
    uploadPFX: (file) => { dispatch(actions.uploadPFX(file)) },
    uploadPFXCte: (file) => { dispatch(actions.uploadPFXCte(file)) },
    passwordPFX: (password) => { dispatch(actions.passwordPFX(password)) },
    setPasswordCtePFX: (password) => { dispatch(actions.setPasswordCtePFX(password)) },
    showDialogManualImport: (enable) => { dispatch(actions.showDialogManualImport(enable)) },
    showDialogNfeError: (enable) => { dispatch(actions.showDialogNfeError(enable)) },
    showDialogCteError: (enable) => { dispatch(actions.showDialogCteError(enable)) },
    hideProperties: (value) => { dispatch(actionsImportFiles.hideProperties(value)) },
    loadConfigurationCte: () => dispatch(actions.findConfigurationCte()),
    loadConfigurationNfe: () => dispatch(actions.findConfigurationNfe()),

    setActiveIntegration: (integrationName, integrationTitle) => { dispatch(actions.setActiveIntegration(integrationName, integrationTitle)) },

    setSapEnabled: (value) => { dispatch(actions.setSapEnabled(value)) },
    setFoccoEnabled: (value) => { dispatch(actions.setFoccoEnabled(value)) },
    setAgileEnabled: (value) => { dispatch(actions.setAgileEnabled(value)) },
    setFullsoftEnabled: (value) => { dispatch(actions.setFullsoftEnabled(value)) },
    setGoogleEnabled: (value) => { dispatch(actions.setGoogleEnabled(value)) },
    setPressierEnabled: (value) => { dispatch(actions.setPressierEnabled(value)) },
    setPromobEnabled: (value) => { dispatch(actions.setPromobEnabled(value)) },
    setSankhyaEnabled: (value) => { dispatch(actions.setSankhyaEnabled(value)) },
    setTotvsEnabled: (value) => { dispatch(actions.setTotvsEnabled(value)) },
    setMessageError: (messageError) => { dispatch(actions.setMessageError(messageError)) },

    generateCredentialsAPI: () => { dispatch(actions.generateCredentialsAPI()) },
    getCredentialsApiWhitelabel: () => { dispatch(actions.getCredentialsApiWhitelabel()) },
  };
};

class HubIntegrationsListPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRows: null,
      filterVisible: true
    };
  }

  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first
    })
  }
  onSort = (e) => {
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField
    })


  }
  onFilter = (e) => {
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      if (key == "oid") {
        filters.push({
          campo: key,
          valor: parseInt(e.filters[key].value),
          tipoFiltro: 'IGUAL_A'
        })
      } else {
        filters.push({
          campo: key,
          valor: e.filters[key].value,
          tipoFiltro: 'CONTEM'

        })
      }
    })
    this.props.applyFilter(filters)
  }
  toggleFilter = () => {
    this.setState(prev => {
      return {
        filterVisible: !prev.filterVisible
      };
    });
  };

  applyFilter = () => {
    const filters = [];
    if (this.props.initialDateFilter && this.props.finalDateFilter) {
      filters.push({
        campo: "nfeDate",
        campoComplementar: "nfeDate",
        valor: this.props.initialDateFilter,
        valorComplementar: this.props.finalDateFilter,
        tipoFiltro: "ENTRE",
      });
    }
    this.props.applyFilter(filters);
  }

  componentDidMount() {
    this.props.hideProperties(true);
    // this.props.setMessageError("");
    
    AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);

    const menuPath = this.props.history.location.pathname;
    // this.props.setCurrentMenu(menuPath);
    // this.applyFilter();  
    this.props.loadConfigurationCte();
    this.props.loadConfigurationNfe();
  }
  componentWillUnmount() {
    AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
    this.props.hideProperties(false);
  }

  onReceiveAppNotifications = (eventName, params) => {
    if (
      eventName === COMPANY_CHANGE_EVENT_NAME ||
      eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME
    ) {
      // this.props.setMessageError("");
      this.props.loadConfigurationCte();
      this.props.loadConfigurationNfe();
      this.props.getCredentialsApiWhitelabel();
    }

  };

  onDownload = e => {
    this.props.downloadHandle(e);
  }

  enableSefazModuleHandler = (e) => {
    this.props.sefazModuleHandler(true);
  }

  enableApiModuleHandler = (e) => {
    // carregar as credenciais de acesso a API
    this.props.getCredentialsApiWhitelabel();
    this.props.apiModuleHandler(true);
  }

  enableEdiModuleHandler = (e) => {
    this.props.ediModuleHandler(true);
  }

  enableManualModuleHandler = (e) => {
    this.props.manualModuleHandler(true);
  }

  showDialogManualImport = (e) => {
    this.props.showDialogManualImport(true);
    this.props.hideProperties(true);
  }
  hideDialogManualImport = (e) => {
    this.props.showDialogManualImport(false);
    this.props.hideProperties(false);
  }

  showDialogErpMenu = (e) => {
    this.props.showDialogErpMenu(true);
  }
  showDialogErpConfiguration = (e) => {
    this.props.showDialogErpMenu(false);
    this.props.showDialogErpConfiguration(true);
  }
  hideDialogErpMenu = (e) => {
    this.props.showDialogErpMenu(false);
  }
  hideDialogErpConfiguration = (e) => {
    this.props.showDialogErpConfiguration(false);
  }

  setActiveIntegrationHandler = (integrationName, integrationTitle) => {
    this.props.setActiveIntegration(integrationName, integrationTitle);
    this.props.showDialogErpConfiguration(true, integrationName);
  }

  sapConfigurationHandler = (e) => {
    this.props.setSapEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  foccoConfigurationHandler = (e) => {
    this.props.setFoccoEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  agileConfigurationHandler = (e) => {
    this.props.setAgileEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  fullsoftConfigurationHandler = (e) => {
    this.props.setFullsoftEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  googleConfigurationHandler = (e) => {
    this.props.setGoogleEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  pressierConfigurationHandler = (e) => {
    this.props.setPressierEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  promobConfigurationHandler = (e) => {
    this.props.setPromobEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  sankhyaConfigurationHandler = (e) => {
    this.props.setSankhyaEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  totvsConfigurationHandler = (e) => {
    this.props.setTotvsEnabled(true);
    this.props.showDialogErpConfiguration(true);
  }

  changeAutHandler = (e) => {
    this.props.changeAutHandler(e.value);
  }

  uploadPFX = (e) => {
    this.props.uploadPFX(e.target.files);
  }

  uploadPFXCte = (e) => {
    this.props.uploadPFXCte(e.target.files);
  }
  passwordPFXHandler = (e) => {
    this.props.passwordPFX(e.target.value);
  }

  setPasswordCtePFX = (e) => {
    this.props.setPasswordCtePFX(e.target.value);
  }

  showDialogNfeError = (e) => {
    this.props.showDialogNfeError(true);
  }
  showDialogCteError = (e) => {
    this.props.showDialogCteError(true);
  }
  hideDialogNfeError = (e) => {
    this.props.showDialogNfeError(false);
  }
  hideDialogCteError = (e) => {
    this.props.showDialogCteError(false);
  }
  templateCustomMessage

  onGenerateCredentialsAPI = () => {
    // this.props.setMessageError("");
    this.props.generateCredentialsAPI();
  }

  render() {
    const header = (
      <div>
        <div>
          <h1>HUB DE INTEGRAÇÕES</h1>
        </div>
        <div className="lxLineToggleHeader">
          <hr className="lxSplitter"></hr>
          <button
            className="lognex-btn-highlighted"
            title={
              this.state.filterVisible ? "Minimizar filtro" : "Maximizar filtro"
            }
            onClick={this.toggleFilter}
          >
            <i
              className={`pi pi-${this.state.filterVisible ? "minus" : "plus"}`}
            ></i>
          </button>
        </div>
        <div
          className={`p-grid lxFilter ${this.state.filterVisible ? "" : "lxFilterInvisible"
            }`}
        >
          <div className={`p-col-11 `}>
            <HubIntegrationsMenu
              enableSefazModuleHandler={this.enableSefazModuleHandler}
              enableApiModuleHandler={this.enableApiModuleHandler}
              enableEdiModuleHandler={this.enableEdiModuleHandler}
              enableManualModuleHandler={this.enableManualModuleHandler}
              hideDialogManualImport={this.hideDialogManualImport}
              showDialogManualImport={this.showDialogManualImport}
              dialogManualImport={this.props.dialogManualImport}
              module={this.props.module}
              logCte={this.props.logCte}
              logNfe={this.props.logNfe}
            />
          </div>

        </div>
      </div>


    );

    const templateCustomMessage = (rowData, column) => {
      if (rowData.message != "") {
        return (
            <span style={{textAlign: "center", color: "red", fontWeight: 'bold' }}>{rowData.message}</span>
        );
      }
    }

    const columns = this.props.columns.map(col => {
      if (col.field == 'message') {
        return <Column key={col.field} field={col.field} header={col.header} style={{ textAlign:"center" }} body={templateCustomMessage} />
      }
      if (col.field == 'date') {
        return <Column key={col.field} field={col.field} header={col.header} style={{ textAlign:"center" }} />
      }
      return (<Column {...col} style={{ textAlign: "center" }} key={col.field} />)
    })

    const content = (
      <>
        {this.props.module.sefaz ? (
          <>
            <SefazConfigurationForm
              uploadPFXHandler={this.uploadPFX}
              uploadPFXCteHandler={this.uploadPFXCte}
              passwordPFXHandler={this.passwordPFXHandler}
              setPasswordCtePFX={this.setPasswordCtePFX}
              passwordNfePFX={this.props.passwordNfePFX}
              passwordCtePFX={this.props.passwordCtePFX}
              currentRecord={this.props.currentRecord}
              logCte={this.props.logCte}
              logNfe={this.props.logNfe}
              showDialogNfeError={this.showDialogNfeError}
              hideDialogNfeError={this.hideDialogNfeError}
              showDialogCteError={this.showDialogCteError}
              hideDialogCteError={this.hideDialogCteError}
              dialogNfeError={this.props.dialogNfeError}
              dialogCteError={this.props.dialogCteError}
              columns={columns}
            />
          </>
        ) : this.props.module.api ? (
          <>
            <ApiConfigurationForm
              integration={this.props.integrations}
              dialogMenuErpHandler={this.showDialogErpMenu}
              hideDialogErpMenu={this.hideDialogErpMenu}
              hideDialogIntegrationConfiguration={this.hideDialogErpConfiguration}
              dialogErpMenu={this.props.dialogErpMenu}
              dialogIntegrationConfiguration={this.props.dialogIntegrationConfiguration}
              dialogIntegrationConfigurationHandler={this.showDialogErpConfiguration}
              autOptions={this.props.autConfigurationOptions}
              autValue={this.props.autConfigurationValue}
              changeAutHandler={this.changeAutHandler}
              setActiveIntegrationHandler={this.setActiveIntegrationHandler}
              sapConfigurationHandler={this.sapConfigurationHandler}
              foccoConfigurationHandler={this.foccoConfigurationHandler}
              agileConfigurationHandler={this.agileConfigurationHandler}
              fullsoftConfigurationHandler={this.fullsoftConfigurationHandler}
              googleConfigurationHandler={this.googleConfigurationHandler}
              pressierConfigurationHandler={this.pressierConfigurationHandler}
              promobConfigurationHandler={this.promobConfigurationHandler}
              sankhyaConfigurationHandler={this.sankhyaConfigurationHandler}
              totvsConfigurationHandler={this.totvsConfigurationHandler}
              onGenerateCredentialsAPI={this.onGenerateCredentialsAPI}
              credentials={this.props.credentials}
              messageError={this.props.messageError}
            />
          </>
        ) : this.props.module.manual ? (
          <>
            <ImportFilesFormPageContainer />
          </>
        ) : (
          <>
            <h1>Nenhum módulo selecionado</h1>
          </>
        )}
      </>
    )

    // const content = <AuditoriaTrackingList  {...this.props} onFilter={this.onFilter} onPage={this.onPage} onSort={this.onSort} columns={columns} onRowClick={this.onRowClick} />;
    return <Page header={header} content={content} />;
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(HubIntegrationsListPageContainer);
